var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container calendar-list-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-input", {
            staticStyle: { width: "200px" },
            attrs: {
              type: "text",
              placeholder: "请输入项目内容",
              clearable: ""
            },
            model: {
              value: _vm.listQuery.activityTitle,
              callback: function($$v) {
                _vm.$set(_vm.listQuery, "activityTitle", $$v)
              },
              expression: "listQuery.activityTitle"
            }
          }),
          _c(
            "el-select",
            {
              staticStyle: { width: "200px" },
              attrs: { clearable: "", placeholder: "请选择活动状态" },
              model: {
                value: _vm.listQuery.activityStatus,
                callback: function($$v) {
                  _vm.$set(_vm.listQuery, "activityStatus", $$v)
                },
                expression: "listQuery.activityStatus"
              }
            },
            [
              _c("el-option", {
                attrs: { label: "未开始", value: "1", selected: "" }
              }),
              _c("el-option", { attrs: { label: "进行中", value: "2" } }),
              _c("el-option", { attrs: { label: "已结束", value: "3" } })
            ],
            1
          ),
          _c(
            "el-select",
            {
              staticStyle: { width: "200px" },
              attrs: { clearable: "", placeholder: "请选择发布状态" },
              model: {
                value: _vm.listQuery.activityPublishStatus,
                callback: function($$v) {
                  _vm.$set(_vm.listQuery, "activityPublishStatus", $$v)
                },
                expression: "listQuery.activityPublishStatus"
              }
            },
            [
              _c("el-option", {
                attrs: { label: "未发布", value: "1", selected: "" }
              }),
              _c("el-option", { attrs: { label: "已发布", value: "2" } })
            ],
            1
          ),
          _c(
            "el-select",
            {
              staticStyle: { width: "200px" },
              attrs: { clearable: "", placeholder: "请选择审核状态" },
              model: {
                value: _vm.listQuery.activityAuditStatus,
                callback: function($$v) {
                  _vm.$set(_vm.listQuery, "activityAuditStatus", $$v)
                },
                expression: "listQuery.activityAuditStatus"
              }
            },
            [
              _c("el-option", {
                attrs: { label: "未审核", value: "1", selected: "" }
              }),
              _c("el-option", { attrs: { label: "审核通过", value: "2" } }),
              _c("el-option", { attrs: { label: "审核不通过", value: "3" } })
            ],
            1
          ),
          _c("el-date-picker", {
            attrs: {
              "value-format": "yyyy-MM-dd HH:mm:ss",
              type: "daterange",
              "range-separator": "至",
              "start-placeholder": "活动开始日期",
              "end-placeholder": "活动结束日期"
            },
            model: {
              value: _vm.dates,
              callback: function($$v) {
                _vm.dates = $$v
              },
              expression: "dates"
            }
          }),
          _c(
            "el-select",
            {
              staticStyle: { width: "200px" },
              attrs: { clearable: "", placeholder: "请选择是否计费" },
              model: {
                value: _vm.listQuery.isCharge,
                callback: function($$v) {
                  _vm.$set(_vm.listQuery, "isCharge", $$v)
                },
                expression: "listQuery.isCharge"
              }
            },
            [
              _c("el-option", { attrs: { label: "不计费", value: "0" } }),
              _c("el-option", { attrs: { label: "计费", value: "1" } })
            ],
            1
          ),
          _c(
            "el-button",
            {
              directives: [{ name: "waves", rawName: "v-waves" }],
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.handleFilter }
            },
            [_vm._v(_vm._s(_vm.$t("button.search")))]
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.list,
            "element-loading-text": "数据正在加载中...",
            border: "",
            stripe: "",
            fit: "",
            "highlight-current-row": ""
          },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: _vm.$t("table.id"), width: "50" }
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "项目内容",
              "min-width": "200px",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.activityTitle))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "项目类型",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.activityTypeName))])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "活动地点",
              "min-width": "120px",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.activityLocation))])
                  ]
                }
              }
            ])
          }),
          !_vm.isBuildParty && !_vm.isDashboard
            ? _c("el-table-column", {
                attrs: {
                  align: "center",
                  width: "110px",
                  label: "计划报名人数"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(scope.row.activityPlannedEnrollment))
                          ])
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3571604563
                )
              })
            : _vm._e(),
          !_vm.isBuildParty && !_vm.isDashboard
            ? _c("el-table-column", {
                attrs: { align: "center", width: "110px", label: "是否计费" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                scope.row.isCharge == 0 ? "不计费" : "计费"
                              )
                            )
                          ])
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2792830302
                )
              })
            : _vm._e(),
          !_vm.isBuildParty && !_vm.isDashboard
            ? _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "报名时间",
                  "min-width": "300px"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _vm._v(" " + _vm._s(scope.row.enrollmentBeginDate)),
                          scope.row.enrollmentEndDate
                            ? _c("span", [
                                _vm._v(
                                  "--" + _vm._s(scope.row.enrollmentEndDate)
                                )
                              ])
                            : _vm._e()
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  972178311
                )
              })
            : _vm._e(),
          !_vm.isBuildParty && !_vm.isDashboard
            ? _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "活动时间",
                  "min-width": "200px"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _vm._v(" " + _vm._s(scope.row.activityBeginDate)),
                          scope.row.enrollmentEndDate
                            ? _c("span", [
                                _vm._v("--" + _vm._s(scope.row.activityEndDate))
                              ])
                            : _vm._e()
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3128249991
                )
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: { align: "center", label: "审核状态", width: "100px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.activityAuditStatus === 2
                      ? _c("span", { staticStyle: { color: "#67c23a" } }, [
                          _vm._v("审核通过")
                        ])
                      : _vm._e(),
                    scope.row.activityAuditStatus === 3
                      ? _c("span", { staticStyle: { color: "#f56c6c" } }, [
                          _vm._v("审核不通过")
                        ])
                      : _vm._e(),
                    scope.row.activityAuditStatus === 1
                      ? _c("span", { staticStyle: { color: "#e6a23c" } }, [
                          _vm._v("未审核")
                        ])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "活动状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.activityStatusName))])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "发布状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(scope.row.activityPublishStatusName))
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: _vm.$t("table.actions"),
              "class-name": "small-padding fixed-width",
              "min-width": "200px"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          size: "mini",
                          plain: "",
                          icon: "el-icon-search"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleCheck(scope.row.id)
                          }
                        }
                      },
                      [_vm._v("查看")]
                    ),
                    scope.row.activityAuditStatus === 1 && !_vm.isDashboard
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "mini",
                              plain: "",
                              icon: "el-icon-news"
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleExamine(scope.row.id)
                              }
                            }
                          },
                          [_vm._v("审核")]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.listQuery.page,
              "page-sizes": [10, 20, 30, 50],
              "page-size": _vm.listQuery.limit,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogFormVisible,
            width: "1200px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            }
          }
        },
        [
          _vm.dialogFormVisible
            ? _c("active-add", {
                attrs: {
                  viewType: "1",
                  "key-value": _vm.id,
                  "is-detail": _vm.isDetail,
                  "is-dashboard": _vm.isDashboard,
                  "is-audit": _vm.isAudit,
                  "show-dialog": _vm.dialogFormVisible
                },
                on: { handCancle: _vm.handCancle }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }